import { IconSvgElement } from "@hugeicons/react";
import { FC, ReactNode } from "react";
import { IconBridge, IconSize } from "shared/components/IconBridge";
import { SVGComponentProps } from "untitledui-js-base";

interface NavLinkContent {
  size: IconSize;
  Icon?: FC<SVGComponentProps>;
  HugeIcon?: IconSvgElement;
  children: ReactNode;
  indicator?: string | number;
}

export const NavLinkContent = ({
  size,
  Icon,
  HugeIcon,
  children,
  indicator
}: NavLinkContent) => (
  <>
    <IconBridge
      size={size}
      Icon={Icon}
      HugeIcon={HugeIcon}
      className="shrink-0"
    />
    {children}
    {indicator ? (
      <span className="absolute left-[4px] top-[2px] min-w-[16px] px-1 text-xxs text-center font-bold rounded text-white bg-primary-500 outline">
        {indicator}
      </span>
    ) : null}
  </>
);
